import { WlcmPaginatedData } from '@wlcm/common';
import { WlcmQueryParams } from '@wlcm/common';
import { createAction, createActionGroup } from '@ngrx/store';
import { ActionsUtils } from '@store/utils';
import { EntityId } from '@core/models';
import { LocationPayload } from '@core/models/entities/location.models';
import { Location } from '@core/models/entities/location.models';

const PREFIX = '[LOCATION API]';

export const LoadLocationsPaginatedActions = createActionGroup({
  source: `${PREFIX} Load Paginated`,
  events: ActionsUtils.makeEventsWithPayload<Partial<WlcmQueryParams>, WlcmPaginatedData<Location>>(),
});
export const LoadLocationsPaginatedMoreActions = createActionGroup({
  source: `${PREFIX} Load Paginated next page`,
  events: ActionsUtils.makeEvents<WlcmPaginatedData<Location>>(),
});

export const PatchLocationAction = createActionGroup({
  source: `${PREFIX} Patch`,
  events: ActionsUtils.makeEventsWithPayloadTherapist<
    { id: EntityId | null; data: Partial<LocationPayload> },
    Location
  >(),
});

export const DeleteLocation = createActionGroup({
  source: `${PREFIX} Delete`,
  events: ActionsUtils.makeEventsWithPayloadTherapist<{ id: EntityId }, { id: string }>(),
});

export const AddLocation = createActionGroup({
  source: `${PREFIX} Add`,
  events: ActionsUtils.makeEventsWithPayload<{ id: null; data: LocationPayload }, Location>(),
});

export const Reset = createAction(`${PREFIX} Reset`);

export const ResetPartial = createAction(`${PREFIX} Reset Partial`);

export const ResetQuery = createAction(`${PREFIX} Reset Query`);
